import BugReportIcon from "@mui/icons-material/BugReport";
import BuildIcon from "@mui/icons-material/Build";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { Box, SxProps, Theme } from "@mui/material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { StepTimeline } from "src/modules/StepTimeline/StepTimeline";

export const DevelopmentFlow = () => {
  // アイコンのimportを追加

  // アイコン定義をここで行う
  const phaseIcons = [
    <WorkOutlineIcon fontSize="large" />,
    <BuildIcon fontSize="large" />,
    <DesignServicesIcon fontSize="large" />,
    <BugReportIcon fontSize="large" />,
    <RocketLaunchIcon fontSize="large" />,
    <MonitorHeartIcon fontSize="large" />,
  ];

  const phases = [
    {
      title: "1. 開発前",
      description: "PM、PdM、企画、デザイナーが主体となり、要件定義やプロジェクト計画を策定します。",
      roles: ["PM", "PdM", "企画", "デザイナー"],
      icon: phaseIcons[0],
    },
    {
      title: "2. 開発初期",
      description: "PM、インフラ、バックエンド、フロント、デザイナーが協力し、基盤構築と設計を行います。",
      roles: ["PM", "インフラ", "バックエンド", "フロント", "デザイナー"],
      icon: phaseIcons[1],
    },
    {
      title: "3. 開発中期",
      description: "PM、インフラ、バックエンド、フロントエンドが主体となり、実装を進めます。",
      roles: ["PM", "インフラ", "バックエンド", "フロントエンド"],
      icon: phaseIcons[2],
    },
    {
      title: "4. 開発後期",
      description: "PM、バックエンド、フロントエンドが中心となり、テストと調整を行います。",
      roles: ["PM", "バックエンド", "フロントエンド"],
      icon: phaseIcons[3],
    },
    {
      title: "5. リリース時",
      description: "PM、インフラ、バックエンド、フロントが再結集し、リリース作業を遂行します。",
      roles: ["PM", "インフラ", "バックエンド", "フロント"],
      icon: phaseIcons[4],
    },
    {
      title: "6. リリース後",
      description:
        "サービス維持のための監視体制や、不具合の修正、追加機能の開発に必要な人材を低工数で集め運用を行います。",
      roles: ["監視", "修正", "追加開発"],
      icon: phaseIcons[5],
    },
  ];

  return (
    <SectionContainer sx={{ background: "white" }}>
      <SectionTitle>システム開発で必要な人材の推移</SectionTitle>
      <StepTimeline
        steps={phases.map((phase) => ({
          icon: phase.icon,
          title: phase.title,
          description: (
            <>
              {phase.description}
              <Box sx={roleBadgeContainerSx}>
                {phase.roles.map((role, roleIndex) => (
                  <Box key={roleIndex} sx={roleBadgeSx}>
                    {role}
                  </Box>
                ))}
              </Box>
            </>
          ),
          color: "info",
        }))}
      />
    </SectionContainer>
  );
};

const roleBadgeContainerSx: SxProps<Theme> = {
  mt: 1,
  display: "flex",
  flexWrap: "wrap",
  gap: 1,
  justifyContent: "flex-start",
};

const roleBadgeSx: SxProps<Theme> = {
  background: "#e3f6fa",
  color: "#22A1B9",
  borderRadius: "16px",
  px: 2,
  py: 0.25,
  fontSize: "0.875rem",
};
